import { Heading, Icon, Pressable, Text } from '@ui/themed';
import type { IconName } from './ui/icon/types';

export type IconCardProps = {
  icon: IconName;
  title: string;
  subtitle: string;
  /** When provided, the whole card becomes a button */
  onClick?: () => void;
};

// A tinted card with a coloured icon tile, a title and a subtitle
function IconCardBody({ icon, title, subtitle }: Omit<IconCardProps, 'onClick'>) {
  return (
    <div className="flex w-full items-center gap-3 rounded-xl bg-platform-primary/5 p-4 text-start">
      <span className="flex size-11 shrink-0 items-center justify-center rounded-lg border border-black/15 bg-platform-primary/10 text-platform-primary">
        <Icon name={icon} size="md" />
      </span>
      <div className="flex min-w-0 flex-col gap-0.5">
        <Heading level="span" style="sm">
          {title}
        </Heading>
        <Text size="sm" variant="secondary">
          {subtitle}
        </Text>
      </div>
    </div>
  );
}

export function IconCard({ onClick, ...props }: IconCardProps) {
  if (!onClick) {
    return <IconCardBody {...props} />;
  }

  return (
    <Pressable type="card" fullWidth fullHeight onClick={onClick}>
      <IconCardBody {...props} />
    </Pressable>
  );
}
